// Formatters centralizados pra display de moeda/data/percentual/etc.
// Antes cada tela reimplementava fmtBRL inline — se alguem mudasse casas
// decimais em 1 arquivo, desalinhava o resto. Auditoria UX 27/07/2026.
/** Moeda BRL padrão brasileiro: "R$ 1.234,56" (2 casas obrigatórias).
 *  Fonte única — não redefinir localmente em cada tela. */
export const fmtBRL = (n) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(n);
/** Moeda BRL "compacta" — sem centavos, pra headline/dashboard onde os
 *  centavos poluem. Ex.: "R$ 1.234". */
export const fmtBRLCompacto = (n) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 }).format(n);
/** Data ISO "2026-08-08" → "08/08/2026". Retorna "—" para vazio/null.
 *  Usar quando o backend devolve string ISO curta (não Date completo). */
export const fmtDataISO = (iso) => {
    if (!iso)
        return "—";
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m)
        return iso;
    return `${m[3]}/${m[2]}/${m[1]}`;
};
/** Percentual em [0..1] → "12,3%". Aceita null/undefined. */
export const fmtPct = (n, casas = 1) => {
    if (n == null || !Number.isFinite(n))
        return "—";
    return `${(n * 100).toFixed(casas).replace(".", ",")}%`;
};
//# sourceMappingURL=formatters.js.map